import { __SCRIPT_WRAPPER, __SCRIPT_WRAPPERASYNC } from "../xone/source/scripts/__SCRIPT_WRAPPER__.js";
export default class XOneJavascript {
    static run(appData, script, ctx, mapRuntimeObjects, Arguments, sMessage = "") {
        __SCRIPT_WRAPPER(appData, appData.getUserInterface(), ctx.getObjectHost(), script, Arguments);
    }
    static async runAsync(appData, script, ctx, mapRuntimeObjects, Arguments, sMessage = "") {
        return __SCRIPT_WRAPPERASYNC(appData, appData.getUserInterface(), ctx.getObjectHost(), script, Arguments);
    }
}

//# sourceMappingURL=XOneJavascript.js.map
